import script from "./PaginationComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationComponent.vue?vue&type=style&index=0&id=f14500ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f14500ba"]])

export default __exports__